<template>
  <el-card class="box-card main-card">
    <el-row type="flex" justify="space-between">
      <el-col :span="24" >
        <el-button type="primary" size="small" @click="toAdd">发布</el-button>
      </el-col>
    </el-row>
    <div style="height: 15px;"></div>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column label="发布时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDateTime}}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="100">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="toDetail(scope.row)">
              查看
            </el-button>
            <el-button type="primary" size="small" @click="toEdit(scope.row)">编辑</el-button>
            <el-button type="primary" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <PageComponent ref="pageInfo"></PageComponent>

  </el-card>
</template>

<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";
    export default {
      components: {PageComponent},
      name: "smsCode",
      props: {
        type:{
          type: String,
          default: '1'
        },
      },
      data() {
        return {
          tableData: [],
        }
      },
      methods: {
        // 获取资讯列表
        getInfomationList: function () {
          var params = {
            page: this.$refs.pageInfo.currentPage,
            pageSize: 10,
            categoryId: this.type
          };

          this.getRequest('/tccTopic/getList', params).then(resp => {
            if (resp.status == 200) {
              if (resp.data.code == 1000) {
                this.tableData = resp.data.result.records;
                this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
              } else {
                Message.error(resp.data.message);
              }
            } else {
              console.error("error")
            }
          })
        },
        toDetail(row) {
          // /contribute/detail?topicId=10020&categoryId=1
          this.$router.push({
            path: '/infomation/detail',
            query: {
              topicId: row.id,
              categoryId: row.categoryId
            }
          })
        },
        // 添加消息
        toAdd() {
          this.$router.push({
            path: '/information/add',
            query:{type:this.type}
          })
        },
        // 编辑消息
        toEdit(row) {
          this.$router.push({
            path: '/information/edit',
            query:{type:this.type,id:row.id}
          })
        },

        handleDelete(row) {
          this.$confirm("确认删除？", "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: 'warning'
          }).then(() => {
            this.doDelete(row);
          }).catch(() => {
            this.$message({
              type: 'info',
              message: "取消"
            });
          });
        },
        doDelete(row) {
          this.postRequestJson("/tccTopic/deleteTopic", {"id": row.id}).then(resp => {
            if (resp && resp.status == 200) {
              var data = resp.data;
              this.getInfomationList()
              this.$message({type: data.status, message: data.message});
            }
          });
        },
      },
      mounted: function () {
        this.getInfomationList()
        this.$refs.pageInfo.initPagenator(this.getInfomationList, null);
      }
    }
</script>

<style scoped>

</style>
